import React from "react";
import { products } from "../../../../../data/Courses";
import { Link } from "react-router-dom";
export default function RelatedUsers() {
  return (
    <div className="related-products">
      <div className="section-container">
        <div className="row">
          <div className="col-12">
            <div className="title">Related Users</div>
          </div>

          {products.slice(0, 4).map((item, index) => (
            <div className="col-lg-3 col-md-6 col-12" key={index}>
              <div
                className="card-item wow fadeInUp"
                data-wow-delay={item.delay}
              >
                <div className="card-media">
                  <img src={item.src} width={300} height={320} alt="" />
                  <div className="more-infor">
                    <a href="#" className="infor-item email">
                      <i className="icon-email" />
                    </a>
                    <a href="#" className="infor-item view">
                      <i className="icon-view" />
                    </a>
                    <a href="#" className="infor-item data">
                      <i className="icon-data" />
                    </a>
                  </div>
                </div>
                <div className="card-content">
                  <h5>
                    <Link href={`/single-product/${item.id}`}>
                      {item.title}
                    </Link>
                  </h5>
                  <div className="price">{item.price}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}